import { LOCALE } from '@foxrenderfarm/internals'
import { navigate } from 'gatsby'

export const customNavigate = (to: string, localeTo: LOCALE, options = {}) => {
  if (typeof window === 'undefined') {
    return
  }
  if (localeTo && localeTo !== LOCALE.EN) {
    navigate(`/${localeTo}${to}`, options)
  } else {
    navigate(to, options)
  }
}
